import { useMemo } from 'react';
import classNames from 'classnames';
import { Checkbox } from '@material-ui/core';

import layoutStyles from '../../../layout.module.css';
import styles from '../../index.module.css';
import EmptyCheck from '../../../components/EmptyCheck';
import { makeMessage, postMessageToParent } from '../../utils';

const HEADER_ROW_2_HEIGHT = 35;

function AssignmentFirstRow({
    rootStyle,
    suppliers,
    columnIndex,
    takePrice,
    isDisabled,
    isFloorPrice,
    isLoading,
    lots
}) {
    const supplier = suppliers[columnIndex - 1];
    const isAllAssigned = useMemo(
        () => lots.every(lot => lot.suppliers[supplier.id]),
        [lots, supplier]
    );

    const handleAssignAll = event => {
        if (isLoading) {
            return;
        }
        const assignAllEvent = makeMessage('assignSupplierAll', {
            checked: event.target.checked,
            supplierIndex: columnIndex - 1
        });
        postMessageToParent(assignAllEvent);
    };

    return (
        <div style={rootStyle}>
            <div
                className={styles.th}
                title={supplier.company_name}
            >
                {supplier.company_name.length > 20 ? supplier.company_name.slice(0, 20) + "..." : supplier.company_name}
            </div>
            <div
                className={classNames(
                    layoutStyles.flex,
                    layoutStyles.row,
                    layoutStyles.borderRight,
                    layoutStyles.borderBottom,
                    styles.headingFont,
                    styles.greyBackground
                )}
            >
                <div
                    className={classNames(
                        layoutStyles.flex,
                        layoutStyles.col,
                        layoutStyles.flex1,
                        layoutStyles.contentCenter,
                        layoutStyles.itemsCenter,
                        styles.headingPad,
                        'assignmentCheck'
                    )}
                    style={{
                        height: HEADER_ROW_2_HEIGHT
                    }}
                    title='Assign Supplier to All Lots'
                >
                    <Checkbox
                        id={'Supplier' + columnIndex + '-InviteAll'}
                        data-supplier={supplier?.company_name}
                        data-purpose='invite-supplier-to-all-lots'
                        icon={<EmptyCheck />}
                        disabled={isDisabled}
                        onChange={handleAssignAll}
                        checked={isAllAssigned}
                    />
                </div>
                {takePrice && (
                    <div
                        style={{
                            width: 169,
                            height: HEADER_ROW_2_HEIGHT
                        }}
                        className={classNames(
                            layoutStyles.flex,
                            layoutStyles.contentCenter,
                            layoutStyles.itemsCenter,
                            layoutStyles.borderLeft
                        )}
                    >
                        {isFloorPrice ? 'Set Floor Price' : 'Set Ceiling Price'}
                    </div>
                )}
            </div>
        </div>
    );
}

export default AssignmentFirstRow;
